export const config = {
  url: 'https://eu.app.unleash-hosted.com/eubb1018/api/frontend',
  clientKey: process.env.UNLEASH_FRONTEND_KEY || 'dummy',
  appName: '7s-portal',
};
